import React, { useCallback, useContext, useEffect, useState } from 'react';
import BoardsContext from '../../../../contexts/BoardsContext';
import isPerformanceBoard from '../../../../isPerformanceBoard';

const usePermittedPerformanceBoards = () => {
  const { boards } = useContext(BoardsContext);
  const getPerformanceBoards = useCallback(() => {
    return boards.filter(isPerformanceBoard).filter((b) => !b.isHidden);
  }, [boards]);

  const [performanceBoards, setPerformanceBoards] =
    useState<PerformanceBoardTypes.Board[]>(getPerformanceBoards);
  useEffect(() => {
    setPerformanceBoards(getPerformanceBoards());
  }, [getPerformanceBoards]);

  return performanceBoards;
};

const usePerformanceBoardOptions = ({
  selectedPerformanceBoard,
  setSelectedPerformanceBoard,
  setTitle,
}: {
  selectedPerformanceBoard: PerformanceBoardTypes.Board | undefined;
  setSelectedPerformanceBoard: React.Dispatch<
    React.SetStateAction<PerformanceBoardTypes.Board | undefined>
  >;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const performanceBoards = usePermittedPerformanceBoards();

  const buildOptions = useCallback((): DropdownOption[] => {
    return performanceBoards.map((d) => ({
      key: d.id,
      label: d.name,
      isSelected:
        !!selectedPerformanceBoard && d.id === selectedPerformanceBoard.id,
      onSelected: () => {
        setSelectedPerformanceBoard(d);
        setTitle(d.name);
      },
    }));
  }, [
    performanceBoards,
    selectedPerformanceBoard,
    setSelectedPerformanceBoard,
    setTitle,
  ]);
  const [options, setOptions] = useState<DropdownOption[]>(buildOptions());
  useEffect(() => {
    setOptions(buildOptions());
  }, [buildOptions]);

  return options;
};

export default usePerformanceBoardOptions;
